/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'circle-arrow-left': {
    width: 38,
    height: 38,
    viewBox: '0 0 38 38',
    data: '<path pid="0" _fill="#203F6A" fill-rule="evenodd" d="M19 0c10.48 0 19 8.52 19 19s-8.52 19-19 19S0 29.48 0 19 8.52 0 19 0zm-6.56 20.28l7.36 7.32c.36.36.8.52 1.28.52s.92-.16 1.28-.52c.679-.68.679-1.84 0-2.52L16.24 19l6.08-6.08c.68-.68.68-1.84 0-2.52-.68-.68-1.84-.68-2.52 0l-7.36 7.36c-.32.32-.52.8-.52 1.279 0 .44.2.881.52 1.24z"/>'
  }
})
